// extracted by mini-css-extract-plugin
module.exports = {"icon":"ShowWorldMapButton_icon__1z4gT","overlay":"ShowWorldMapButton_overlay__3oW-F","content":"ShowWorldMapButton_content__3dApX"};